/**
 * Comment l'enfant appelle celui qui lui envoie un bravo.
 *
 * « Maman » ou « Papa » quand le parent l'a dit à l'inscription
 * (household_members.parent_type, copié sur le bravo à l'envoi) : c'est ainsi
 * que l'enfant l'appelle, pas par son prénom. Pour les autres rôles
 * (beau-parent, grand-parent, tuteur…), le mot du formulaire d'inscription
 * n'est pas celui de l'enfant : on garde le prénom. Sans rien, `null`, et
 * l'appelant dit « un message pour toi ».
 */

const CALLED_BY_ROLE = ['mom', 'dad'] as const

export function cheerSenderLabel(
  senderType: string | null | undefined,
  senderName: string | null | undefined,
  t: (key: string) => string,
): string | null {
  if (senderType && (CALLED_BY_ROLE as readonly string[]).includes(senderType)) {
    return t(`cheer.sender.${senderType}`)
  }
  return senderName?.trim() || null
}
